import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Projects from '../components/Projects';
import About from '../components/About';
import GitHubStats from '../components/GitHubStats';
import Contact from '../components/Contact';
import EasterEggs from '../components/EasterEggs';
import Footer from '../components/Footer';
import BlogPreview from '../components/BlogPreview';

const Home = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <Projects />
      <About />
      <GitHubStats />
      <BlogPreview />
      <Contact />
      <EasterEggs />
      <Footer />
    </>
  );
};

export default Home;